import type React from "react";
import styles from "./Card.module.css";

interface CardProps extends React.ComponentProps<"div"> {
	children: React.ReactNode;
	className?: string;
}

export const Card = ({ children, className = "", ...props }: CardProps) => (
	<div className={`${styles.card} ${className}`} {...props}>
		{children}
	</div>
);
